import { RefObject } from "react";

export const convertPosition = (PopupPositon: number, popupRef: RefObject<HTMLDivElement | null>): string => {
    let newPopupPosition;
    const popupHeight = popupRef && popupRef.current?.clientHeight;

    const screenHeight = window.innerHeight;
    const isBigger = popupHeight && PopupPositon + popupHeight > screenHeight;
    if (popupHeight && isBigger) {
        newPopupPosition =
            screenHeight < 815
                ? (PopupPositon / screenHeight / 1.5) * 100
                : (newPopupPosition = (PopupPositon / screenHeight) * 100);
        return `calc(${newPopupPosition}% - 150px`;
    } else {
        newPopupPosition = (PopupPositon / screenHeight) * 100;
        return `calc(${newPopupPosition}%`;
    }
};
